// frontend/src/components/AdminRoute.js
import { useAuth } from '../contexts/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

/**
 * Protected route that requires admin user_type.
 * Redirects to login if not authenticated, to home if not admin.
 */
function AdminRoute() {
  const { isLoggedIn, isAdmin, isAuthReady } = useAuth();

  // Wait for auth initialization - show loading
  if (!isAuthReady) {
    return (
      <div className="loading-overlay">
        <div className="app-loader" />
        <p>Loading…</p>
      </div>
    );
  }

  // Not logged in - redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Logged in but not admin - redirect to dashboard
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Admin user - render the protected content
  return (
    <div className="admin-layout" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Outlet />
    </div>
  );
}

export default AdminRoute;
